import { render, staticRenderFns } from "./AttCardInfo.vue?vue&type=template&id=aa52fe84&"
import script from "./AttCardInfo.vue?vue&type=script&lang=js&"
export * from "./AttCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports